import { useEffect, useState } from "react"

//Document Sign components
import docSignStyles from "../../../styles/documentSigning/DocSign.filters.module.css"

//PrimeReact
import { Calendar } from "primereact/calendar"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Tooltip } from "primereact/tooltip"

export default function TemplateFilters({
  filters,
  sortOptions,
  onChangeFilters,
  onChangeSortField,
}) {
  const sortDirections = [
    { value: "Descending", icon: "arrow_downward" },
    { value: "Ascending", icon: "arrow_upward" },
  ]

  const [dateFilter, setDateFilter] = useState(null)
  const [sortField, setSortField] = useState(sortOptions[0])
  const [sortDirection, setSortDirection] = useState(sortDirections[0])
  const [searchPhrase, setSearchPhrase] = useState("")

  useEffect(() => {
    if (filters.sort !== sortField) {
      setSortField(filters.sort)
    }

    if (filters.sortDirection !== sortDirection.value) {
      if (sortDirection.value === sortDirections[0].value) {
        setSortDirection(sortDirections[1])
      } else {
        setSortDirection(sortDirections[0])
      }
    }

    //Note: Disable exhaustive deps due to only wanting to fire this event when filters change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return (
    <div className={docSignStyles.templateGridContainer}>
      <Tooltip target={".tt-ds-templates-filter"} />
      <div className={docSignStyles.CreateDate}>
        <div className={docSignStyles.label}>Filter by Date Created: </div>
        <div className={docSignStyles.dateInput}>
          <Calendar
            value={dateFilter}
            onChange={(e) => setDateFilter(e.value)}
            selectionMode="range"
            readOnlyInput
            placeholder="Click to select dates"
            style={{ width: "100%" }}
          />
        </div>
      </div>
      <div className={docSignStyles.templateGridSort}>
        <div className={docSignStyles.label}>Sort templates: </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Dropdown
            value={sortField}
            options={sortOptions}
            onChange={(e) => {
              const newSort = {
                sort: e.value,
                sortDirection: sortDirection.value,
              }
              setSortField(e.value)
              onChangeSortField(newSort)
            }}
            style={{ width: "100%", margin: "0px" }}
          />
          <button
            className={`btn ${docSignStyles.sortDirection} tt-ds-templates-filter`}
            onClick={() => {
              const newDirection =
                sortDirection.value === sortDirections[0].value
                  ? sortDirections[1]
                  : sortDirections[0]
              const newSort = {
                sort: sortField,
                sortDirection: newDirection.value,
              }

              setSortDirection(newDirection)
              onChangeSortField(newSort)
            }}
            data-pr-tooltip={`${sortDirection.value}, click to change to ${
              sortDirection.value === sortDirections[0].value
                ? sortDirections[1].value
                : sortDirections[0].value
            }`}
            data-pr-position="bottom"
          >
            <span className="material-icons ">{sortDirection.icon}</span>
          </button>
        </div>
      </div>
      <div className={docSignStyles.templateGridSearch}>
        <div className={docSignStyles.label}>Search:</div>
        <div>
          <InputText
            value={searchPhrase}
            onChange={(e) => {
              setSearchPhrase(e.target.value)
            }}
            className={docSignStyles.searchText}
            placeholder="Type to search"
          />
        </div>
        <div className={docSignStyles.filterHelpText}>
          Search on: Title, Document(s) or Metadata
        </div>
      </div>
      <div className={docSignStyles.templateGridButtons}>
        <div className={docSignStyles.filterButtons}>
          <button
            className={`btn ds_template_tt`}
            type="button"
            onClick={() => {
              onChangeFilters({
                dateCreated: dateFilter,
                search: searchPhrase,
                sort: sortField,
                sortDirection: sortDirection.value,
              })
            }}
          >
            Apply
          </button>
          <button
            className={`btn ${docSignStyles.filterButton}`}
            type="button"
            onClick={() => {
              setSearchPhrase("")
              setDateFilter(null)
              onChangeFilters({ dateCreated: null, search: "" })
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  )
}
